import styled from 'styled-components';
import { Link as LinkRouterDom } from 'react-router';

export const Container = styled.footer`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 35px 15px;
    background-color: #fff;
    color: #4a4a4a;
`;

export const Navigation = styled.nav`
    margin: 0 auto;
`;

export const NavList = styled.ul`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
    @media (max-width: 640px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const NavItem = styled.li`
    margin: 0 24px 0 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
        margin-right: 0;
    }
    @media (max-width: 640px) {
        margin: 0 0 16px 0;
        &:last-child {
            margin: 0;
        }
    }
`;

export const Link = styled(LinkRouterDom)`
    margin: 0;
    padding: 16px 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #4b5563;
    text-decoration: none;
`;

export const ExternalLink = styled.a`
    margin: 0;
    padding: 16px 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #4b5563;
    text-decoration: none;
`;

export const Copyright = styled.p`
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #4b5563;
`;
